export default __webpack_public_path__ + "static/media/white-spinner.f7894a60.svg";